import {Row, Col, Card, Tag, Button, Empty} from "antd";
import {useNavigate} from "react-router-dom";
import {
    DollarOutlined,
    CalendarOutlined,
    CreditCardOutlined,
} from "@ant-design/icons";
import {HISTORY_ROUTE, PAY_ROUTE, PAYMENTS_ROUTE} from "../../utils";

const StudentGroupsCards = ({studentGroups}) => {
    const navigate = useNavigate();

    const cardActions = [
        {
            icon: <DollarOutlined/>,
            label: "Пополнить",
            path: (id) => `${PAY_ROUTE}/${id}`,
        },
        {
            icon: <CalendarOutlined/>,
            label: "Посещения",
            path: (id) => `${HISTORY_ROUTE}/${id}`,
        },
        {
            icon: <CreditCardOutlined/>,
            label: "Оплаты",
            path: (id) => `${PAYMENTS_ROUTE}/${id}`,
        },
    ];

    if (!studentGroups || studentGroups.length === 0) {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                    <span style={{color: '#999'}}>
                            Нет групп
                        </span>
                }
            />
        );
    }

    return (
        <Row gutter={[16, 16]} style={{margin: "1vw"}}>
            {studentGroups.map((group) => (
                <Col key={group.key} xs={24} sm={24} md={12} lg={12} xl={8}>
                    <Card
                        hoverable
                        style={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                        bodyStyle={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                        title={
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                <span
                    style={{
                        flex: 1,
                        overflow: "hidden",
                        whiteSpace: "wrap",
                    }}
                    title={group.name}
                >
                  {group.name}
                </span>
                                <Tag
                                    style={{
                                        whiteSpace: "wrap",
                                        maxWidth: '35%',
                                        marginTop: '1vh',
                                        marginBottom: '1vh',
                                        marginRight: 0
                                    }}
                                >{group.technology}</Tag>
                            </div>
                        }
                        actions={cardActions.map((action) => (
                            <Button
                                key={action.label}
                                type="link"
                                size="small"
                                className="custom-link"
                                icon={action.icon}
                                onClick={() => navigate(action.path(group.id))}
                            >
                                <span style={{textDecoration: 'underline'}}>{action.label}</span>
                            </Button>
                        ))}
                    >
                        <p style={{margin: "0 0 0.5rem 0"}}>
                            <strong>Расписание:</strong> {group.schedule}
                        </p>
                        <p style={{margin: "0 0 0.5rem 0"}}>
                            <strong>Баланс:</strong> {group.balance}
                        </p>
                        <p style={{margin: 0}}>
                            <strong>Бонусный баланс:</strong> {group.bonusBalance}
                        </p>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StudentGroupsCards;